<template>
  <el-dialog
    :visible.sync="visible"
    @close="handleClose"
    width="340px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :destroy-on-close="true"
    :center="true"
    :show-close="false"
    custom-class="cannot-place-order"
    top="25vh"
    :lock-scroll="true"
    :append-to-body="true"
  >
    <div class="custom-header">
      <div class="title">温馨提示</div>
      <i class="el-icon-close" @click="handleClose"></i>
    </div>
    <div class="text-box">
      <p>尊敬的客户，由于系统正在进行升级，</p>
      <p>暂无法支持线上下单功能。如有疑问</p>
      <p>或需要其他帮助，请随时联系客服。</p>
    </div>
    <div class="wx-service">
      <img :src="servicePicUrl || qrCodeImages.wxService" alt="">
    </div>
    <p class="tip-text">扫一扫 联系客服</p>
  </el-dialog>
</template>

<script>
import {qrCodeImages} from "../devParams.js";
export default {
  name: 'cannot-place-order',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    servicePicUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      qrCodeImages
    }
  },
  watch: {
    show: {
      handler(val) {
        this.visible = val
      },
      immediate: true
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:show', false)
    }
  },
  mounted() {
    
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  border-radius: 12px;
  overflow: hidden;
  user-select: none;
  &__header {
    display: none;
  }
  &__body {
    padding-top: 16px;
    background: linear-gradient( 180deg, #FEF0EB 0%, #FFFFFF 100%);
  }
  .custom-header {
    display: flex;
    justify-content: center;
    position: relative;
    align-items: center;
    .title {
      font-weight: 600;
      font-size: 16px;
      color: #333333;
    }
    i {
      font-size: 20px;
      font-weight: bold;
      position: absolute;
      right: 0;
      cursor: pointer;
      color: #666666;
      font-weight: 500;
      &:hover {
        opacity: .8;
        color: #FF4D01;
      }
    }
  }
  .text-box {
    margin-top: 14px;
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 14px;
    color: #333333;
    line-height: 20px;
    p {
      margin: 0;
    }
  }
  .wx-service {
    margin: 18px auto 0;
    width: 150px;
    height: 150px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px dashed #EEEEEE;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .tip-text {
    margin-top: 10px;
    font-size: 12px;
    color: #999999;
    line-height: 17px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// common/cannot-place-order.vue